__turbopack_context__.v({
  "dimmed": "iC3d_q_dimmed",
  "faqFeedback": "iC3d_q_faqFeedback",
  "iconButton": "iC3d_q_iconButton",
  "iconButtonSelected": "iC3d_q_iconButtonSelected",
  "iconButtonWrapper": "iC3d_q_iconButtonWrapper",
  "label": "iC3d_q_label",
  "resetButton": "iC3d_q_resetButton",
});
